/**
 * @generated SignedSource<<6ee13655924f5a35af050b8b877a967c>>
 * @relayHash ba6d684cf52c39f4ae2f3df43c85672b
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 2f11c713a96724e751e78f3213b049b7d422e35c18f6ceb2d703da611c377ebc

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { backlogFilterRefinementQuery } from './backlogFilterRefinementQuery.graphql';

const node: PreloadableConcreteRequest<backlogFilterRefinementQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "2f11c713a96724e751e78f3213b049b7d422e35c18f6ceb2d703da611c377ebc",
    "metadata": {},
    "name": "backlogFilterRefinementQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
